import { Component, OnInit } from '@angular/core';

import { ApiService } from '../../services/api.service';
import { LoaderComponent } from '../../components/layout/loader/loader.component';
import { interval, Subscription } from 'rxjs';
import { HttpClient } from '@angular/common/http';

import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { PageHeaderComponent } from '../../components/page-header/page-header.component';

@Component({
  selector: 'app-platform-status',
  standalone: true,
  imports: [LoaderComponent, PageHeaderComponent, CommonModule, FormsModule],
  templateUrl: './platform-status.component.html',
  styleUrl: './platform-status.component.scss'
})
export class PlatformStatusComponent implements OnInit {

  devItems: any[] = [];
  prodItems: any[] = [];
  loading = false;
  activeTab: 'dev' | 'prod' = 'prod';

  resyncing: { [key: string]: boolean } = {};
  lastResync: { [key: string]: string } = {};

  private pollSub?: Subscription;

  constructor(
    private apiService: ApiService,
    private http: HttpClient
  ) { }

  ngOnInit(): void {
    const stored = localStorage.getItem('resyncDates');
    this.lastResync = stored ? JSON.parse(stored) : {};

    this.loadData();

    // 🔁 poll every 30 seconds
    this.pollSub = interval(30000).subscribe(() => {
      this.loadData();
    });
  }

  ngOnDestroy(): void {
    this.pollSub?.unsubscribe(); // prevent memory leak
  }

  loadData() {
    this.loading = true;

    this.apiService.get("/office/platform-status").then((data: any) => {
      this.devItems = data['dev'] || [];
      this.prodItems = data['prod'] || [];
      this.loading = false;
    }).catch(() => {
      this.loading = false;
    });
  }

  resync(item: any) {
    if (!item?.id) return;

    let self = this;
    this.resyncing[item.id] = true;

    this.apiService.post(`/office/platform-status/sync/${item.id}`, {}).then(function (response) {
        let nowDate = new Date().toISOString();

        self.lastResync[item.id] = nowDate;
        localStorage.setItem('resyncDates', JSON.stringify(self.lastResync));

        self.resyncing[item.id] = false;
    }).catch(function () {
        self.resyncing[item.id] = false;
    });
  }
}
